/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetFlatAreasDesktopRequest,
  TGetFlatAreasDesktopModel,
  IMappers,
  TGetFlatAreasDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicGetFlatAreasResponse } from '../../entities/flat_areas/PublicGetFlatAreasResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetFlatAreasDesktopModel(parameters: IGetFlatAreasDesktopRequest): TGetFlatAreasDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/v1/get-flat-areas-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetFlatAreasDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFlatAreasDesktopRequest;
}

export async function fetchGetFlatAreasDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFlatAreasDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetFlatAreasDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFlatAreasDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetFlatAreasDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicGetFlatAreasResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFlatAreasDesktopResponse>;
}
